import {PopupCodeTriggerRestDto} from "@/api/pharma-cms-popup/models";

export class PopupCodeTriggerRestDtoModel implements PopupCodeTriggerRestDto {
    js_event: string;
    css_selector: string;

    constructor(js_event: string, css_selector: string) {
        this.js_event = js_event;
        this.css_selector = css_selector;
    }

    public static createWithDefaults(): PopupCodeTriggerRestDtoModel {
        return new this('', '');
    }
}
